<template>
        <div v-show="show" @click="close()">
                <div class="emotion-box" :style="{ 'left': x + 'px', 'top': y + 'px' }">
                        <div class="emotion-tabs">
                                <div class="emotion-tab" :class="{ active: tab == 'normal' }" @click.stop="tab = 'normal'">表情</div>
                                <div class="emotion-tab" :class="{ active: tab == 'sticker' }" @click.stop="tab = 'sticker'">大表情</div>
                        </div>
                        <el-scrollbar style="height: 220px">
                                <div class="emotion-items" v-show="tab == 'normal'">
                                        <div class="emotion-item" v-for="(emoText, i) in $emo.emoTextList" :key="i"
                                                @click="onClickEmo(emoText)" v-html="$emo.textToImg(emoText,'emoji-large')">
                                        </div>
                                </div>
                                <div class="emotion-items" v-show="tab == 'sticker'">
                                        <div class="emotion-item sticker-item" v-for="(emoText, i) in $emo.emoTextList" :key="'s'+i"
                                                @click="onClickSticker(emoText)">
                                                <img :src="$emo.textToUrl('#' + emoText + ';')" />
                                        </div>
                                </div>
                        </el-scrollbar>
                </div>
        </div>
</template>

<script>
export default {
        name: "emotion",
        data() {
                return {
                        show: false,
                        tab: 'normal',
                        pos: {
                                x: 0,
                                y: 0
                        }
                }
        },
        methods: {
                onClickEmo(emoText) {
                        let emotion = `#${emoText};`
                        this.$emit('emotion', emotion)
                },
                onClickSticker(emoText) {
                        // 大表情：发送图片URL
                        let url = this.$emo.textToUrl(`#${emoText};`)
                        this.$emit('sticker', url)
                },
                open(pos) {
                        this.pos = pos;
                        this.tab = 'normal';
                        this.show = true;
                },
                close() {
                        this.show = false;
                }
        },
        computed: {
                x() {
                        return this.pos.x - 22;
                },
                y() {
                        return this.pos.y - 234;
                }
        }
}
</script>
<style scoped lang="scss">
.emotion-box {
        position: fixed;
        width: 372px;
        box-sizing: border-box;
        padding: 5px;
        background-color: #fff;
        box-shadow: var(--im-box-shadow);

        .emotion-tabs {
                display: flex;
                border-bottom: 1px solid #eee;
                margin-bottom: 5px;

                .emotion-tab {
                        padding: 6px 16px;
                        cursor: pointer;
                        font-size: 13px;

                        &.active {
                                color: var(--im-color-primary);
                                border-bottom: 2px solid var(--im-color-primary);
                        }
                }
        }

        .emotion-items {
                display: flex;
                flex-wrap: wrap;

                .emotion-item {
                        text-align: center;
                        cursor: pointer;
                        padding: 2px;
                }

                .sticker-item {
                        width: 60px;
                        height: 60px;

                        img {
                                width: 100%;
                                height: 100%;
                                object-fit: contain;
                        }

                        &:hover {
                                background: var(--im-background-active);
                        }
                }
        }
}
</style>
